import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { adminApi } from "../lib/api";

/**
 * Fetches admin-overridden SEO for the current page key and applies it
 * via document.title / meta description / canonical.
 *
 * Falls back silently to component-level SEO defaults if no override exists.
 */
export default function PageSeoOverride({ pageKey }) {
  const location = useLocation();
  const [override, setOverride] = useState(null);
  const [tried, setTried] = useState(false);

  useEffect(() => {
    if (!pageKey) return;
    setTried(false);
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/page-seo/${pageKey}`
    )
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        setOverride(d);
        setTried(true);
      })
      .catch(() => setTried(true));
  }, [pageKey]);

  useEffect(() => {
    if (!override) return;
    if (override.title) document.title = override.title;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", override.description);

    if (override.canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", override.canonical);
    }
  }, [override, location.pathname]);

  // No render — purely side-effect
  if (!tried) return null;
  return null;
}
